import React, { useEffect, useState } from 'react';
import axios from '../axiosConfig';
import Footer from '../components/Footer';
import MainEventos from '../components/MainEventos';
import ModalCodigo from '../components/ModalCodigo';
import ModalPerfil from '../components/ModalPerfil';
import ModalRecuperar from '../components/ModalRecuperar';
import NavBar from '../components/NavBar';
import { handleError, toastError, toastInfo } from '../funciones';
import { Tutorial } from '../components/Tutorial';
//import images from '../images';

function Eventos() {

    const [perfil, setPerfil] = useState({ rubros: [], rubrosSinFormato: [], productosOfrecidos: [], productosDemandados: [], representantes: [], notificaciones: [] , nombre:''});
    /*const itemsNavBar = [
            { id: 'tab-eventos', nombre: 'Eventos', logo: images.logoCalendario, url: '/' },
            { id: 'tab-empresas', nombre: 'Empresas', logo: images.logoEmpresas, url: '/empresas' },
            { id: 'tab-actividades', nombre: 'Configuración', logo: images.logoReuniones, url: '/configuracion' }
        ];*/

    useEffect(() => {

        const params = {
            params: {
                id: localStorage.getItem(process.env.REACT_APP_ID_EMPRESA)
            }
        }

        axios.get(process.env.REACT_APP_URL + "empresa/perfil", params)
            .then(function (response) {
                setPerfil(response.data);
            })
            .catch(function (error) {
                toastError(handleError(error))
            });
        document.getElementById("ofertaDemanda").classList.remove("d-none");
        document.getElementById("datosRepresentante").classList.remove("d-none");
        if (localStorage.getItem(process.env.REACT_APP_BIENVENIDA)) {
            localStorage.removeItem(process.env.REACT_APP_BIENVENIDA)
            toastInfo("Bienvenido")
        }
    }, [])

    return (
        <>
            <NavBar notificaciones={perfil.notificaciones} ultimaVez={perfil.ultimaVez} logo={perfil.rubroUrl}/>
            <MainEventos />
            <ModalPerfil perfil={perfil} isEditar={true} setPerfil={setPerfil} />
            <Footer />
            <ModalCodigo />
            <ModalRecuperar />
            <Tutorial initialId={5} />
        </>
    );
}


export default Eventos;